(()=>{
 'use strict';
 const root=document.getElementById('bs-locator');
 if(!root||root.dataset.ready)return;
 const labels=JSON.parse(document.getElementById('bs-dealer-labels').textContent);
 const list=root.querySelector('#bs-list'),count=root.querySelector('#bs-count'),map=root.querySelector('#bs-gmap'),form=root.querySelector('#bs-form'),input=root.querySelector('#bs-input');
 const dealers=[];
 const collect=node=>{
  if(!node||typeof node!=='object')return;
  if(Array.isArray(node)){node.forEach(collect);return;}
  if(node['@type']==='AutoDealer'&&node.name&&node.address){
   const a=node.address,address=typeof a==='string'?a:[a.streetAddress,a.addressLocality,a.addressRegion,a.postalCode,a.addressCountry].filter(Boolean).join(', ');
   if(!dealers.some(d=>d.name===node.name&&d.address===address))dealers.push({name:node.name,address,phone:node.telephone||''});
  }
  Object.values(node).filter(v=>v&&typeof v==='object').forEach(collect);
 };
 document.querySelectorAll('script[type="application/ld+json"]').forEach(s=>{try{collect(JSON.parse(s.textContent))}catch{}});
 if(!dealers.length){count.textContent=labels.unavailable;return;}
 root.dataset.ready='true';
 function el(tag,cls,text){const e=document.createElement(tag);if(cls)e.className=cls;if(text)e.textContent=text;return e;}
 count.setAttribute('role','status');count.setAttribute('aria-live','polite');
 const cards=el('div','bs-dealer-cards');list.append(cards);
 const frame=el('iframe','bs-dealer-frame');frame.loading='eager';frame.referrerPolicy='no-referrer-when-downgrade';frame.allowFullscreen=true;
 const detail=el('div','bs-dealer-selected'),note=el('p','bs-dealer-map-note',labels.map_note),status=el('p','bs-dealer-status');status.setAttribute('role','status');status.setAttribute('aria-live','polite');form.insertAdjacentElement('afterend',status);
 map.replaceChildren(detail,frame,note);
 const directions=d=>'https://www.google.com/maps/dir/?api=1&destination='+encodeURIComponent(d.address);
 function link(text,url){const a=el('a','',text);a.href=url;if(!url.startsWith('tel:')){a.target='_blank';a.rel='noopener noreferrer';}return a;}
 let selected=null;
 function select(d,reveal=false){
  selected=d;
  detail.replaceChildren(el('small','',labels.selected),el('h3','',d.name),el('p','',d.address),link(labels.directions,directions(d)));
  frame.title=labels.map.replace('__NAME__',d.name);
  frame.src='https://maps.google.com/maps?q='+encodeURIComponent(d.address)+'&z=13&output=embed';
  cards.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.address===d.address&&b.dataset.name===d.name)));
  if(reveal&&matchMedia('(max-width:767px)').matches)root.querySelector('.bs-map').scrollIntoView({behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth',block:'start'});
 }
 function render(){
  const terms=input.value.trim().toLowerCase().split(/\s+/).filter(Boolean),found=dealers.filter(d=>terms.every(t=>(d.name+' '+d.address).toLowerCase().includes(t)));
  count.textContent=labels.count.replace('__COUNT__',found.length);cards.replaceChildren();
  if(!found.length){cards.append(el('p','bs-dealer-empty',labels.empty));return;}
  for(const d of found){
   const card=el('article','bs-dealer-card'),b=el('button','bs-dealer-name',d.name);b.type='button';b.dataset.name=d.name;b.dataset.address=d.address;b.title=labels.view_map;b.setAttribute('aria-pressed',String(selected===d));b.addEventListener('click',()=>select(d,true));
   const actions=el('div','bs-dealer-actions');if(d.phone)actions.append(link(d.phone,'tel:'+d.phone.replace(/[^\d+]/g,'')));actions.append(link(labels.directions,directions(d)));
   card.append(b,el('p','',d.address),actions);cards.append(card);
  }
  if(!found.includes(selected))select(found[0]);
 }
 form.addEventListener('submit',e=>{e.preventDefault();status.textContent='';render();});input.addEventListener('input',()=>{status.textContent='';render();});
 root.querySelector('#bs-locate')?.addEventListener('click',()=>{
  if(!navigator.geolocation){status.textContent=labels.location_denied;return;}
  status.textContent=labels.location_wait;
  navigator.geolocation.getCurrentPosition(p=>{
   const coords=p.coords.latitude+','+p.coords.longitude;
   selected=null;cards.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed','false'));
   detail.replaceChildren(el('h3','',labels.your_location));frame.title=labels.your_location;frame.src='https://maps.google.com/maps?q='+encodeURIComponent(coords)+'&z=10&output=embed';status.textContent=labels.location_found;
  },()=>{status.textContent=labels.location_denied;},{timeout:10000,maximumAge:60000});
 });
 render();
})();
